"use client";

import Lottie from "lottie-react";
import { useState } from "react";
import { useCookieFlag } from "@/hooks/use-cookie";
import logoAnimation from "@/public/animations/logo.json";

const SPLASH_COOKIE_NAME = "articollect_splash_seen";
const COOKIE_TTL_DAYS = 7;

export function Splash() {
  const [hasSeenSplash, setHasSeenSplash, isLoaded] = useCookieFlag(
    SPLASH_COOKIE_NAME,
    { days: COOKIE_TTL_DAYS },
  );
  const [isAnimating, setIsAnimating] = useState(true);

  const handleAnimationComplete = () => {
    // Set cookie so splash won't show for 1 week
    setHasSeenSplash(true);

    // Start fade out
    setTimeout(() => {
      setIsAnimating(false);
    }, 300);
  };

  // Don't render if user has already seen splash (after cookie check)
  if (isLoaded && hasSeenSplash) return null;

  // Show black overlay while loading OR during splash animation
  const showOverlay = !isLoaded || isAnimating;

  return (
    <div
      className={`fixed inset-0 bg-black z-[51] flex justify-center items-center transition-opacity duration-500 ease-out pointer-events-none ${
        showOverlay ? "opacity-100" : "opacity-0"
      }`}
      aria-hidden="true"
    >
      {isLoaded && (
        <Lottie
          animationData={logoAnimation}
          loop={false}
          autoplay={true}
          className="w-4/5 md:w-3/5 -translate-y-1/12 md:translate-0"
          onComplete={handleAnimationComplete}
        />
      )}
    </div>
  );
}
